import React from 'react';
import PropTypes from 'prop-types';
import styles from './DrawerDetailFooter.css';

function DrawerDetailFooter({ children }) {
  return <div className={styles.DrawerDetailFooter}>{children}</div>;
}

DrawerDetailFooter.propTypes = {
  children: PropTypes.node,
};

export default DrawerDetailFooter;
